module.exports = __webpack_public_path__ + "static/media/circle-marker-light.94480050.svg";